// src/routes/index.jsx
import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/HomePage'));
const CalculatorPage = lazy(() => import('../pages/CalculatorPage'));
const TheoryPage = lazy(() => import('../pages/TheoryPage'));
const GlossaryPage = lazy(() => import('../pages/GlossaryPage'));
const MethodGuidePage = lazy(() => import('../pages/MethodGuidePage'));
const ExamplesPage = lazy(() => import('../pages/ExamplesPage'));
const LabsPage = lazy(() => import('../pages/LabsPage'));
const AboutPage = lazy(() => import('../pages/AboutPage'));
const PrivacyPolicyPage = lazy(() => import('../pages/PrivacyPolicyPage'));
const TermsPage = lazy(() => import('../pages/TermsPage'));
const NotFoundPage = lazy(() => import('../pages/NotFoundPage'));

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/calculator" element={<CalculatorPage />} />
      <Route path="/theory" element={<TheoryPage />} />
      <Route path="/glossary" element={<GlossaryPage />} />
      <Route path="/method-guide" element={<MethodGuidePage />} />
      <Route path="/examples" element={<ExamplesPage />} />
      <Route path="/labs" element={<LabsPage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="/terms-of-service" element={<TermsPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default AppRoutes;
